module.exports = __webpack_public_path__ + "static/media/matematyka.77372de6.png";